import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createRowActions } from "@msuite/ui/table";
import { YesNoTag } from "@msuite/ui/tag";
import { moment } from "@msuite/utils/date";
import { guardString } from "@msuite/utils/strings";
import { UserCard } from "@/components/cards";
import { ApprovalAssignmentCell } from "./approval-assignment-cell";
import { ApprovalRowActions } from "./approval-row-actions";
import { ApprovalStateCell } from "./approval-state-cell";
import type { ApprovalRow } from "./approval-row";

const columnHelper = createColumnHelper<ApprovalRow>();

export const columns = [
	columnHelper.accessor("chainOrder", {
		id: "chainOrder",
		header: localized("incoming_invoices.decision.chain_position"),
		cell: (cell) => cell.getValue() ?? guardString(null),
		size: 90,
	}),
	columnHelper.accessor((row) => guardString(row.user.name), {
		id: "user",
		header: localized("incoming_invoices.approver"),
		cell: (cell) => (
			<UserCard
				userId={cell.row.original.user.id}
				variant="plain"
			/>
		),
	}),
	columnHelper.accessor("assignment", {
		id: "assignment",
		header: localized("incoming_invoices.handover.asked_by"),
		cell: (cell) => <ApprovalAssignmentCell approval={cell.row.original} />,
	}),
	columnHelper.accessor("isSoleApprover", {
		id: "isSoleApprover",
		header: localized("incoming_invoices.handover.sole_label"),
		cell: (cell) => <YesNoTag value={cell.getValue()} />,
		size: 150,
	}),
	columnHelper.accessor("state", {
		id: "state",
		header: localized("incoming_invoices.approval_state.state"),
		cell: (cell) => <ApprovalStateCell approval={cell.row.original} />,
	}),
	columnHelper.accessor("decidedAt", {
		id: "decidedAt",
		header: localized("incoming_invoices.decided_at"),
		cell: (cell) => {
			const decidedAt = cell.getValue();
			return decidedAt ? moment(decidedAt).longFormat() : guardString(null);
		},
	}),
	columnHelper.accessor("comment", {
		id: "comment",
		header: localized("incoming_invoices.approval_comment"),
		cell: (cell) => guardString(cell.getValue()),
	}),
	createRowActions(ApprovalRowActions),
];
